"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameStateSystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
const GameData_1 = require("../../../Shared/GameData");
class GameStateSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.GAME_STATE);
        this.lastUid = 0;
        this.handleInventoryChange = this.handleInventoryChange.bind(this);
    }
    onClear() {
    }
    gameStateInitialized() {
        return !!this.gameState;
    }
    onInit() {
        this.addApi(this.gameStateInitialized);
        this.addApi(this.getUid);
        this.addApi(this.updateHoney);
        this.addApi(this.addHoney);
        this.addApi(this.needsTutorial);
    }
    updateFlowerInterface() {
        const flowerCount = this.$api.getNumberOfFullGrownFlowers();
    }
    updateBeeInterface() {
        const beeCount = this.$api.getNumberOfBees();
        this.bt.text = `${beeCount}/50`;
        if (beeCount >= 50) {
            if (this.youwin)
                return;
            this.$api.getNomTook().onNextDialogue({
                npcComments: ['HOW COULD THIS HAPPEN!?!? ALL THESE BEES!! WHERE DID THEY COME FROM!?!??',]
            }, () => {
                this.$api.getNomTook().onNextDialogue({
                    npcComments: ['IT WAS YOU WASNT IT!?']
                }, () => {
                    this.$api.getNomTook().onNextDialogue({
                        npcComments: ['You know what? I do\'nt even care.?']
                    }, () => {
                        this.$api.getNomTook().onNextDialogue({
                            npcComments: ['PLEASE STOP THESE BEES']
                        }, () => {
                        });
                    });
                });
            });
            const youwin = new PIXI.extras.BitmapText('YOU WIN! It took you ' + Math.round(this.globals.totalElapsedTime) + ' seconds to revive the bee population! Congratulations, Nom Took has lost everything!', { font: 'goldlarge' });
            this.youwin = youwin;
            youwin.maxWidth = 400;
            this.globals.tileWorld.interfaceManager.addChild(youwin);
            const screenWidth = this.globals.renderer.screen.width;
            const screenHeight = this.globals.renderer.screen.height;
            try {
                youwin.updateTransform();
            }
            catch (err) {
            }
            youwin.x = (screenWidth / 2) - (youwin.width / 2);
            youwin.y = (screenHeight / 2) - (youwin.height / 2);
        }
    }
    addHoney(honey) {
        this.gameState.data.honey += honey;
        this.gameState.save();
        this.dispatchAllLocal({
            type: Constants_1.MESSAGES.PLAYER_HONEY_UPDATE,
            data: this.gameState.data.honey,
        });
    }
    updateHoney(honey) {
        this.gameState.data.honey = honey;
        this.gameState.save();
        this.dispatchAllLocal({
            type: Constants_1.MESSAGES.PLAYER_HONEY_UPDATE,
            data: honey,
        });
    }
    onLocalMessage(message) {
        switch (message.type) {
            case Constants_1.MESSAGES.FLOWER_FULLY_GROWN:
            case Constants_1.MESSAGES.REMOVED_FLOWER:
                this.updateFlowerInterface();
                break;
            case Constants_1.MESSAGES.SPAWNED_BUG:
            case Constants_1.MESSAGES.REMOVED_BUG:
                this.updateBeeInterface();
                break;
            case Constants_1.MESSAGES.FINISH_NPC_TASK:
                this.handleFinishNPCTask(message.data);
                break;
            case Constants_1.MESSAGES.ADDED_HOLE:
                this.handleAddedHole(message.data.x, message.data.y, message.data.uid);
                break;
            case Constants_1.MESSAGES.REMOVED_HOLE:
                this.handleRemovedDrop({ level: 'island', uid: message.data });
                break;
            case Constants_1.MESSAGES.DROP_ITEM:
                this.handleDrop(message.data);
                break;
            case Constants_1.MESSAGES.REMOVE_DROPPED_ITEM:
                this.handleRemovedDrop(message.data);
                break;
        }
    }
    handleFinishNPCTask(npcName) {
        this.gameState.data.npcData[npcName].task++;
        if (npcName === 'nomTook' && this.gameState.data.npcData[npcName].task === 1) {
            this.gameState.data.npcData.nomTook.position = Object.assign({}, GameData_1.TOM_NOOK_SHOP_POSITION);
            this.dispatchAllLocal({
                type: Constants_1.MESSAGES.FINISHED_TUTORIAL
            });
        }
        this.gameState.save();
    }
    validateAndGetLevelStateObject(level) {
        const found = this.gameState.data.levels.find(l => l.name === level);
        if (!found)
            throw new Error(`Didnt find level data for ${level}`);
        return found;
    }
    handleAddedHole(x, y, uid) {
        const levelData = this.validateAndGetLevelStateObject('island');
        levelData.state.items.push({
            x, y, uid, name: 'hole'
        });
        this.gameState.save();
    }
    handleDrop(dropEvent) {
        const { level, data } = dropEvent;
        const levelData = this.validateAndGetLevelStateObject(level);
        levelData.state.items.push(Object.assign({}, data));
        this.gameState.save();
    }
    handleRemovedDrop(dropEvent) {
        const { level, uid } = dropEvent;
        const levelData = this.validateAndGetLevelStateObject(level);
        const item = levelData.state.items.find(i => i.uid === uid);
        if (!item)
            throw new Error(`No item found with uid ${uid}`);
        levelData.state.items.splice(levelData.state.items.indexOf(item), 1);
        this.gameState.save();
    }
    handleInventoryChange(event) {
        const { quantity, name, type, index } = event;
        const found = this.gameState.data.inventory.find(i => i.name === name);
        if (type === "add") {
            this.gameState.data.inventory.push({ quantity, name, index });
        }
        else {
            if (!found || found.name !== name)
                throw new Error(`Did not find item at inventory ${name} ${index}`);
            if (type === "remove") {
                this.gameState.data.inventory.splice(this.gameState.data.inventory.indexOf(found), 1);
            }
            else if (type === "update") {
                found.quantity += quantity;
            }
            else {
                throw new Error(`Invalid type.`);
            }
        }
        this.gameState.save();
    }
    onPeerMessage(peerId, message) {
    }
    onStart() {
        this.bc = new PIXI.Container();
        this.bs = new PIXI.Sprite(this.globals.gameTextures.items.icons.bee);
        this.bt = new PIXI.extras.BitmapText('0/50', { font: 'gold' });
        this.bc.addChild(this.bs);
        this.bc.addChild(this.bt);
        this.bt.x = this.bs.texture.width;
        this.globals.tileWorld.interfaceManager.addChild(this.bc);
        this.realignInterface();
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.realignInterface);
        }
        else if (typeof document !== 'undefined') {
            document.addEventListener('resize', this.realignInterface);
        }
    }
    realignInterface() {
        const screenWidth = this.globals.renderer.screen.width;
        const screenHeight = this.globals.renderer.screen.height;
        this.bc.x = screenWidth - 100;
        this.bc.y = screenHeight - 30;
    }
    needsTutorial() {
        if (this.gameState) {
            if (!this.gameState)
                throw new Error(`Check after game state initialized.`);
            return this.gameState.data.npcData.nomTook.task === 0;
        }
        else if (this.globals.gameStateData) {
            return this.globals.gameStateData.npcData.nomTook.task === 0;
        }
        else {
            throw new Error(`No state`);
        }
    }
    onEntityAddedComponent(entity, component) {
        this.gameState = component;
        this.lastUid = component.data.lastUid;
        // do the event listeners in a set timeout to make sure the entity has the inventory component when listening.
        setTimeout(() => {
            this.dispatchAllLocal({
                type: Constants_1.MESSAGES.GAME_STATE_INITIALIZED,
                data: component.data
            });
            entity.on(Constants_1.PLAYER_EVENTS.INVENTORY_CHANGE, this.handleInventoryChange);
        }, 0);
    }
    getUid() {
        if (!this.gameStateInitialized())
            throw new Error(`getUid should not be called before the game state is initialized.`);
        this.gameState.data.lastUid++;
        this.gameState.save();
        return this.gameState.data.lastUid;
    }
    onServerMessage(message) {
    }
    update(delta) {
        this.globals.totalElapsedTime += delta;
    }
}
exports.GameStateSystem = GameStateSystem;
//# sourceMappingURL=module.js.map